export const TOKEN = 'auth:token';

export const MODULOS_STORAGE = {
  modulos: 'permitidos',
};

export const USER_STORAGE = {
  userId: 'id-usuario',
  trocasenha: 'troca-senha',
  instrucoes: 'troca-senha-instrucoes',
};

export const RECEBIMENTO_STORAGE = {
  createFrom: 'recebimento:create-from',
  createBefore: 'recebimento:create-before',
  page: 'recebimento:page',
  sort: 'recebimento:sort',
  search: 'recebimento:search',
  textofiltro: 'recebimento:textofiltro',
  textofiltropessoa: 'recebimento:textofiltropessoa',
  textofiltropropriedade: 'recebimento:textofiltropropriedade',
  pessoa: 'recebimento:pessoa',
  propriedade: 'recebimento:propriedade',
};

export const RECEBIMENTO_RESUMO_STORAGE = {
  createFrom: 'pesagem:create-from',
  createBefore: 'pesagem:create-before',
  page: 'pesagem:page',
  sort: 'pesagem:sort',
  search: 'pesagem:search',
  textofiltropessoa: 'pesagem:textofiltropessoa',
  textofiltropropriedade: 'pesagem:textofiltropropriedade',
  pessoa: 'pesagem:pessoa',
  propriedade: 'pesagem:propriedade',

};

export const PESAGEM_STORAGE = {
  createFrom: 'pesagem:create-from',
  createBefore: 'pesagem:create-before',
  page: 'pesagem:page',
  sort: 'pesagem:sort',
  search: 'pesagem:search',
  textofiltropessoa: 'pesagem:textofiltropessoa',
  textofiltromotorista: 'pesagem:textofiltromotorista',
  pessoa: 'pesagem:pessoa',
  motorista: 'pesagem:motorista',
  tipo: 'pesagem:tipo',
  materiaprima: 'pesagem:materiaprima',
  situacao: 'pesagem:situacao',
};

export const FILA_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
  interval: 'interval',
};
